export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./Painel.html?vue&type=template&id=c07a79c6&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/painel/Painel.html?vue&type=template&id=c07a79c6&
// module id = 516
// module chunks = 1